export function generateUniqueCode(name: string, type: string, codeLength: number = 5): string {
  const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const maxRandom = Math.pow(possibleChars.length, codeLength);
  const hashNum = name.split('').reduce((acc, val) => acc + val.charCodeAt(0), 0) + type.length;
  let randNum = Math.floor(Math.random() * maxRandom) + hashNum;
  let code = '';
  while (randNum > 0 && code.length < codeLength) {
    code = possibleChars.charAt(randNum % possibleChars.length) + code;
    randNum = Math.floor(randNum / possibleChars.length);
  }
  return code;
}
